import React, { useEffect } from 'react';
import { withFormik } from 'formik';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { ErrorList } from '../components/ErrorList';
import { useHistory } from 'react-router-dom';

function RemoveConfirmInner({ handleSubmit, values, formQuestions, updateValues }) {
  const { trackPageView, trackEvent } = useMatomo();
  const history = useHistory();
  values.matomo = { trackEvent };

  useEffect(() => {
    trackPageView({
      documentTitle: 'Remove Confirm - Report Suspicious Chemical Activity'
    });
    trackEvent({
      category: 'Remove Confirm',
      action: 'Started',
    });
  }, []);
  const onCancel = (e) => {
    e.preventDefault();
    updateValues(values, 'product-review');
  };

  return (
    <div>
      <a
        className="govuk-back-link"
        href="#"
        onClick={() => history.goBack()}
      >
        Back
      </a>
      <main
        className="govuk-main-wrapper govuk-main-wrapper--auto-spacing"
        id="content"
        role="main"
        tabIndex={0}
      >
        <div className="govuk-grid-row">
          <div className="govuk-grid-column-two-thirds">
            <h1 className="govuk-label-wrapper">
              <label className="govuk-label govuk-label--l">
                Remove this product?
              </label>
            </h1>
            <ErrorList questions={formQuestions} />
            <form onSubmit={handleSubmit}>
              <p className="govuk-body govuk-!-margin-bottom-9">
                This can’t be undone
              </p>
              <div className="govuk-button-group">
                <button
                  type="submit"
                  data-prevent-double-click="true"
                  className="govuk-button"
                  data-module="govuk-button"
                  data-test="button-continue"
                  aria-label="confirm-remove-product"
                >
                  Confirm
                </button>
                <button
                  onClick={onCancel}
                  data-prevent-double-click="true"
                  className="govuk-button govuk-button--secondary"
                  data-module="govuk-button"
                  data-test="button-cancel"
                  aria-label="cancel-remove-product"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
}
const RemoveConfirm = withFormik({
  validateOnMount: false,
  validateOnBlur: false,
  validateOnChange: false,

  mapPropsToValues: (props) => ({
    ...props.initialValues,
  }),

  handleSubmit: (values, { props, setSubmitting }) => {
    values.matomo.trackEvent({
      category: 'Remove Confirm',
      action: 'Completed',
    });
    const idx = values.productRemoveIndex;
    if (typeof idx === 'number' && idx >= 0 && idx < values.products.length) {
      values.products.splice(idx, 1);
      values.products.forEach((p, i) => {
        p.id = i;
      });
      values.productIndex = Math.max(0, values.products.length - 1);
      const filtered = values.products.filter(
        p => p.product_name && p.product_name.trim() !== ""
      );
      localStorage.setItem("products", JSON.stringify(filtered));
    }
    props.updateValues(values, 'product-review');
    setSubmitting(false);
  },
})(RemoveConfirmInner);

export { RemoveConfirm };
